// extracted by mini-css-extract-plugin
module.exports = {"root":"Consultations_root__1FgDA","info":"Consultations_info__2SZva","consultationsList":"Consultations_consultationsList__1ZGLj","content":"Consultations_content__1O8xi"};